/* eslint-disable */
// This file is generated by dev/generateInitialLangFallback.ts. Do not edit it manually.

import type { LangPackStringValue } from '../../api/types';
import type { LangKey } from '../../types/language';

export default {
  "WrongNumber": "号码错误？",
  "SentAppCode": "我们已将验证码发送至您其他设备上的 **Telegram** 应用。",
  "LoginJustSentSms": "我们已通过短信向您发送验证码，请在上方输入。",
  "LoginHeaderPassword": "输入密码",
  "LoginEnterPasswordDescription": "您已启用两步验证，因此您的账户受额外密码保护。",
  "StartText": "请确认您的国家代码\n并输入您的手机号码。",
  "LoginPhonePlaceholder": "您的手机号码",
  "LoginNext": "下一步",
  "LoginQRLogin": "通过二维码登录",
  "LoginQRTitle": "扫描二维码登录 Telegram",
  "LoginQRHelp1": "在手机上打开 Telegram",
  "LoginQRHelp2": "前往 **设置** > **设备** > **连接桌面设备**",
  "LoginQRHelp3": "将手机对准此屏幕以确认登录",
  "LoginQRCancel": "通过手机号登录",
  "LoginPasskey": "使用通行密钥登录",
  "YourName": "您的姓名",
  "LoginRegisterDesc": "输入您的姓名并添加头像。",
  "LoginRegisterFirstNamePlaceholder": "名字",
  "LoginRegisterLastNamePlaceholder": "姓氏",
  "LoginSelectCountryTitle": "国家",
  "CountryNone": "未找到国家",
  "PleaseEnterPassword": "输入您的新密码",
  "ErrorPhoneNumberInvalid": "手机号码无效，请重试",
  "ErrorCodeInvalid": "验证码无效，请重试",
  "ErrorIncorrectPassword": "密码错误，请重试",
  "ErrorPasswordFlood": "尝试次数过多，请稍后重试",
  "ErrorPhoneBanned": "此手机号码已被封禁",
  "ErrorFloodTime": "尝试次数过多，请在 {time} 后重试",
  "ErrorUnexpected": "意外错误",
  "ErrorUnexpectedMessage": "意外错误: {error}"
} as Record<LangKey, LangPackStringValue>;
